import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the FilterPositionView.
 * @extends JetView
 */
export default class FilterPositionView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section of the form
        const left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text', // Text input for ID
                    name: 'Id',
                    type: 'number',
                    label: _("<span class='icon-drivers-license-o'></span>ID"),
                    labelPosition: 'top',
                    placeholder: _('ID'),
                },
                {
                    view: 'combo', // Combo box for Area selection
                    name: 'Area',
                    id: 'Area',
                    label: _('Área'),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                },
            ],
        };

        // Center left section of the form
        const center_left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text', // Text input for Document
                    name: 'Document',
                    label: _('Documento'),
                    labelPosition: 'top',
                    placeholder: _('Documento'),
                },
                {
                    view: 'richselect', // Rich select for IsActivate status
                    name: 'IsActivate',
                    label: "<span class='icon-state'></span>" + _('Estado'),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    options: [
                        { id: 'null', value: _('Todos') },
                        { id: 'A', value: _('Activado') },
                        { id: 'I', value: _('Inactivado') },
                    ],
                },
            ],
        };

        // Center right section of the form
        const center_right = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text', // Text input for Name
                    name: 'Name',
                    label: "<span class='icon-user'></span>" + _('Nombre'),
                    labelPosition: 'top',
                    placeholder: _('Nombre'),
                },
            ],
        };

        // Right section of the form
        const right = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'combo', // Combo box for Position selection
                    name: 'Position',
                    id: 'Position',
                    label: _('Cargo'),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                },
            ],
        };

        // Upper section containing all the form fields
        const upper_section = {
            id: 'a1',
            rows: [
                {
                    responsive: 'a1',
                    margin: 10,
                    cols: [left, center_left, center_right, right],
                },
            ],
        };

        // Button section for actions
        const buttons = {
            margin: 5,
            cols: [
                {},
                {
                    view: 'button', // Button to add employee
                    value: _('Añadir Empleado'),
                    type: 'form',
                    autowidth: true,
                    hidden: !devConfig.getPermAction('accountingEmployeesAdd', 'Add'), // Conditional visibility based on permissions
                    css: 'prm-accountingEmployeesAdd',
                    click: () => {
                        this.app.callEvent('addEmployees:button', [{}]); // Event call for adding employee
                    },
                },
                {
                    view: 'button', // Button to clear form
                    value: _('Limpiar'),
                    autowidth: true,
                    click: () => {
                        this.getRoot().clear(); // Clear form fields
                    },
                },
                {
                    view: 'button', // Button to consult/filter employees
                    value: _('Consultar'),
                    hotkey: 'enter',
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        this.app.callEvent('employees:filter', [filterdata]); // Event call for filtering employees
                    },
                },
            ],
        };

        // Return the complete form configuration
        return {
            view: 'form',
            rows: [upper_section, buttons],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and loads data for dropdowns.
     */
    init() {
        // Load Position options via AJAX
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json',
            })
            .post(devConfig.geturlApi() + 'Accounting/GetPositionSelect', '', {
                error: function (text, data, XmlHttpRequest) {
                    webix.message('Error! '); // Error message on failure
                },
                success: function (text, data, XmlHttpRequest) {
                    var resp = JSON.parse(text); // Parse response
                    $$('Position').define('options', resp.Data); // Define options for Position dropdown
                    $$('Position').refresh(); // Refresh dropdown
                },
            });

        // Load Area options via AJAX
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json',
            })
            .post(devConfig.geturlApi() + 'Accounting/GetAreaSelect', '', {
                error: function (text, data, XmlHttpRequest) {
                    webix.message('Error! '); // Error message on failure
                },
                success: function (text, data, XmlHttpRequest) {
                    var resp = JSON.parse(text); // Parse response
                    $$('Area').define('options', resp.Data); // Define options for Area dropdown
                    $$('Area').refresh(); // Refresh dropdown
                },
            });
    }
}

// FILE DOCUMENTED
